const SvgLockBlack = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M8 10.0001V7.00006C7.99904 6.02579 8.35368 5.08467 8.99737 4.35333C9.64107 3.62199 10.5295 3.15072 11.496 3.02798C12.4625 2.90523 13.4406 3.13945 14.2467 3.68667C15.0528 4.23388 15.6314 5.05648 15.874 6.00006M12 15.0001C12.2652 15.0001 12.5196 14.8947 12.7071 14.7072C12.8946 14.5196 13 14.2653 13 14.0001C13 13.7348 12.8946 13.4805 12.7071 13.293C12.5196 13.1054 12.2652 13.0001 12 13.0001C11.7348 13.0001 11.4804 13.1054 11.2929 13.293C11.1054 13.4805 11 13.7348 11 14.0001C11 14.2653 11.1054 14.5196 11.2929 14.7072C11.4804 14.8947 11.7348 15.0001 12 15.0001ZM12 15.0001V18.0001M6.6 10.0001H17.4C18.28 10.0001 19 10.7201 19 11.6001V18.6001C19 19.9201 17.92 21.0001 16.6 21.0001H7.4C6.08 21.0001 5 19.9201 5 18.6001V11.6001C5 10.7201 5.72 10.0001 6.6 10.0001Z"
        stroke="#161617"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SvgLockBlack;
